import useTranslation from '../../hooks/useTranslation'
import Headline from '../ui/Headline'
import Text from '../ui/Text'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'
import one from '../../../assets/image/build/1.png'
import two from '../../../assets/image/build/2.png'
import three from '../../../assets/image/build/3.png'
import icon from '../../../assets/image/build/box.png'

function Build() {
  const t = useTranslation()
  const { title, intro, stepLabel, steps } = t.landing.build
  const images = [one, two, three]
  return (
    <FullHeightContainer center id="build">
      <div>
        <Container>
          <SlideInView>
            <div className="mb-4 flex items-center gap-5">
              <img src={icon} alt="" className="h-16" />
              <Headline headline={title} monster bold />
            </div>
            <Text text={intro} size="xlarge" />

            <div className="flex flex-col gap-20 md:gap-24 mt-10">
              {steps.map((step, index) => {
                return (
                  <div key={step.stepNumber} className="flex flex-col md:flex-row gap-12 md:gap-10 items-center">
                    <img src={images[index]} alt="" className="w-60 shrink-0 h-full max-h-32 object-contain" />
                    <div className="flex flex-col justify-center">
                      <Text text={stepLabel + ' 0' + (index + 1)} size="medium" bold />
                      <Headline headline={step.title} size="large" className="my-2" />
                      <Text text={step.text} size="medium" />
                    </div>
                  </div>
                )
              })}
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default Build
